// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__cPpEo","checkboxCol":"Table_checkboxCol__WvKcU","emailCol":"Table_emailCol__1g8uF","actionCol":"Table_actionCol__MaLsZ"};